<template>
  <!-- <p>企業參訪 {{ this.$route.params.id }}</p> -->
  <div class="page_wrapper container-fluid enterprise_visit_area">
    <div class="row page_header enterprise_visit_header">
      <enterprise-visit-header />
    </div>
    <div class="row enterprise_visit_details_content">
      <enterprise-visit-details-content />
    </div>
  </div>
</template>
<script>
import EnterpriseVisitHeader from '~components/pages/enterprise-visits/EnterpriseVisitHeader'
import EnterpriseVisitDetailsContent from '~components/pages/enterprise-visits/EnterpriseVisitDetailsContent'
export default {
  name: 'EnterpriseVisitDetails',
  routerName: 'Enterprise-visits:id',
  components: {
    EnterpriseVisitHeader,
    EnterpriseVisitDetailsContent
  }
}
</script>
